module.exports = __webpack_public_path__ + "static/media/enabledVerticalEventIcon.885ce3be.svg";